import {Modal} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import React from "react";
import {isNotEmpty} from "../../../../_metronic/helpers";

type Props = {
    key?: string;
    text?: string;
    onDelete?:Function;
    onCancel?:Function;
    show:boolean
}
export const DeleteConfirmation = (props: Props) => {
    return (
        <Modal
            show={props.show}
            onClick={() => {
                if(props?.onCancel) {
                    props?.onCancel();
                }
            }}
            centered={true}
            backdrop='static'
        >
        <Modal.Body className='pt-5'>
            <div className=''>
                <div style={{padding: '20px'}} className='d-flex justify-content-center'>
                    {
                        isNotEmpty(props.key) && <FormattedMessage id={props?.key} defaultMessage={'Êtes-vous certain(e) de vouloir supprimer'} />
                    }
                    {
                        isNotEmpty(props.text) && props.text
                    }
                </div>
                <div className='d-flex flex-row align-items-center justify-content-evenly'>
                    <button
                        type='submit'
                        className='btn btn-secondary'
                        onClick={() => {
                            if(props?.onCancel) {
                                props?.onCancel();
                            }
                        }}
                    >
                <span className='indicator-label'>
                  <FormattedMessage id='CANCEL' />
                </span>
                    </button>
                    <button className='btn btn-primary' onClick={() => {
                        if(props?.onDelete) {
                            props?.onDelete();
                        }
                    }}>
                <span className='indicator-label'>
                  <FormattedMessage id='I_UNDERSTOOD' defaultMessage="J'accepte" />
                </span>
                    </button>
                </div>
            </div>
        </Modal.Body>
        </Modal>
    );
};
